module.exports = __webpack_public_path__ + "static/media/transmutr_logo_text_filled.13ad03cc.svg";